// 게임 시계 읽기를 받아 게임 시각(초)을 이어서 세는 추적기 (순수 함수).
// 시계 숫자는 가끔 못 읽히거나(약 20%) 한 자리가 틀리게 읽히므로, 시계가 초당 1씩 올라가는 성질로 보정한다.
// - 처음에는 서로 맞는 읽기 2번이 있어야 확정한다(오인식 한 번으로 시작하지 않게).
// - 확정된 뒤 예상(기준 + 흐른 시간)과 toleranceSec 안이면 기준을 갱신하고, 크게 어긋난 읽기는 무시한다.
//   어긋난 읽기가 confirmCount번 연속 서로 맞으면 새 기준으로 바꾼다.
// - 읽지 못하는 동안에도 실제 흐른 시간만큼 이어서 센다.

export function createClockTracker({ toleranceSec = 4, confirmCount = 3 } = {}) {
  let anchor = null; // { sec, at(ms) }
  let candidate = null; // { sec, at, count }

  const predict = (base, atMs) => base.sec + (atMs - base.at) / 1000;

  const trackCandidate = (sec, atMs, needed) => {
    if (candidate && Math.abs(predict(candidate, atMs) - sec) <= toleranceSec) {
      candidate = { sec, at: atMs, count: candidate.count + 1 };
    } else {
      candidate = { sec, at: atMs, count: 1 };
    }
    if (candidate.count >= needed) {
      anchor = { sec, at: atMs };
      candidate = null;
    }
  };

  return {
    update(sec, atMs) {
      if (sec === null || sec === undefined) {
        return;
      }
      if (!anchor) {
        trackCandidate(sec, atMs, 2);
      } else if (Math.abs(predict(anchor, atMs) - sec) <= toleranceSec) {
        anchor = { sec, at: atMs };
        candidate = null;
      } else {
        trackCandidate(sec, atMs, confirmCount);
      }
    },
    elapsedAt(atMs) {
      return anchor ? predict(anchor, atMs) : null;
    },
    reset() {
      anchor = null;
      candidate = null;
    },
  };
}
